module.exports = __webpack_public_path__ + "img/tablet-restaurante.b0f3f23e.png";